export { default as Close } from './Close'



// WEBPACK FOOTER //
// ./src/core/icons/Close/index.js